module.exports = __webpack_public_path__ + "img/anniu3ac.f1dbbfc5.png";